export enum NotificationChannel {
    EMAIL = 'email',
    PUSH = 'push',
    SMS = 'sms',
    WHATSAPP = 'whatsapp'
}
